// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1xw3G","footer":"ModalInfo_footer__CtqnU"};